import { AxiosError } from 'axios';
import { EventBusFactory } from '@utilities/event-bus';
import { BackendResponseMapper, BaseError, BaseResponseError, ResponseError } from '../error';

const EventBus = EventBusFactory.resolve('global');

/**
 * ### This represent an Aspect that transform any exception
 *
 * @author <pino0071@gmail.com> Jose Aburto
 */
export default class CatchErrorAspect {
  execute() {
    return this;
  }

  catch(error: BaseResponseError | AxiosError): ResponseError {
    const mappedError = BackendResponseMapper.from(error);
    EventBus.dispatch('ERROR_EVENT', mappedError);

    throw new BaseError(mappedError);
  }
}
